// extracted by mini-css-extract-plugin
module.exports = {"download-receipt":"nYQwf","wrapper":"_2gBwW","heading":"zG32y","item":"FIv1R","date":"_1kB1o","number":"_3qd4R","link":"_2Fezm","empty-row":"TxYJ5"};